import { fromJS } from "immutable"

import {
    HOMEPAGE_LOADED,
    SET_FOOTER_PAGES,
    SET_ERA_CHURCHES,
    SET_SELECTED_STORIES,
    SET_NEWS_BOX
} from "./../actions/index"

const initialState = fromJS({
    loaded: false,
    newsBox: null,
    footerPages: null,
    eraChurches: null,
    selectedStories: null,
})

function homeReducer (state = initialState, action) {
    switch (action.type) {
    case HOMEPAGE_LOADED:
        return state.set("loaded", true)
    case SET_FOOTER_PAGES:
        return state.set("footerPages", action.data)
    case SET_ERA_CHURCHES:
        return state.set("eraChurches", action.data)
    case SET_SELECTED_STORIES:
        return state.set("selectedStories", action.data)
    case SET_NEWS_BOX:
        return state.set("newsBox", action.data)
    default:
        return state
    }
}

export default homeReducer



// WEBPACK FOOTER //
// ./src/reducers/home.js